import {StateConstructor, StateMachineConfig} from '@gongxigames/framework/slotV2/fsm/stateMachineTypes';
import {IdleUIState} from '@gongxigames/framework/slotV2/ui/states/IdleUIState';
import {SpinUIState} from '@gongxigames/framework/slotV2/ui/states/SpinUIState';
import {FreeGameUIState} from '@gongxigames/framework/slotV2/ui/states/FreeGameUIState';
import {RespinIdleUIState} from '@gongxigames/framework/slotV2/ui/states/RespinIdleUIState';
import {RespinSpinUIState} from '@gongxigames/framework/slotV2/ui/states/RespinSpinUIState';
import {AutoplaySpinUIState} from '@gongxigames/framework/slotV2/ui/states/AutoplaySpinUIState';
import {DisabledUIState} from '@gongxigames/framework/slotV2/ui/states/DisabledUIState';
import {InitSettingsUIState} from '@gongxigames/framework/slotV2/ui/states/InitSettingsUIState';
import {AutoplayStartUIState} from '@gongxigames/framework/slotV2/ui/states/AutoplayStartUIState';
import {BuyFeaturePopUpUIState} from '@gongxigames/framework/slotV2/ui/states/BuyFeaturePopUpUIState';
import {RestoreUIState} from '@gongxigames/framework/slotV2/ui/states/RestoreUIState';
import {HoldForTurboUIState} from '@gongxigames/framework/slotV2/ui/states/HoldForTurboUIState';
import {AutoplayStopUIState} from '@gongxigames/framework/slotV2/ui/states/AutoplayStopUIState';
import {PickBonusUIState} from '@gongxigames/framework/slotV2/ui/states/PickBonusUIState';
import {AutoplayIdleUIState} from '@gongxigames/framework/slotV2/ui/states/AutoplayIdleUIState';
import {AutoplayDisabledUIState} from '@gongxigames/framework/slotV2/ui/states/AutoplayDisabledUIState';

const checkFeatureTransitions: StateConstructor[] = [
    DisabledUIState,
    FreeGameUIState,
    RespinSpinUIState,
    RespinIdleUIState,
    PickBonusUIState
];

export const uiStateMachineConfig: StateMachineConfig = {
    entryStateId: InitSettingsUIState,
    statesList: [
        {state: IdleUIState, transitions: [HoldForTurboUIState, BuyFeaturePopUpUIState, DisabledUIState, SpinUIState]},
        {state: BuyFeaturePopUpUIState, transitions: [SpinUIState, IdleUIState]},
        {state: DisabledUIState, transitions: [...checkFeatureTransitions, AutoplayStartUIState, IdleUIState]},
        {state: InitSettingsUIState, transitions: [RestoreUIState, IdleUIState]},

        {state: AutoplayStartUIState, transitions: [AutoplaySpinUIState]},
        {state: AutoplaySpinUIState, transitions: [AutoplayStopUIState, AutoplayDisabledUIState, AutoplayIdleUIState, ...checkFeatureTransitions, IdleUIState]},
        {state: AutoplayIdleUIState, transitions: [AutoplayDisabledUIState, AutoplaySpinUIState, IdleUIState]},
        {state: AutoplayDisabledUIState, transitions: [FreeGameUIState, RespinSpinUIState, RespinIdleUIState, AutoplayIdleUIState, IdleUIState]},
        {state: AutoplayStopUIState, transitions: [IdleUIState]},

        {state: SpinUIState, transitions: [...checkFeatureTransitions, IdleUIState]},
        {state: RestoreUIState, transitions: [...checkFeatureTransitions, IdleUIState]},
        {state: FreeGameUIState, transitions: [...checkFeatureTransitions, AutoplayIdleUIState, IdleUIState]},
        {state: RespinIdleUIState, transitions: [RespinSpinUIState, AutoplayDisabledUIState, DisabledUIState]},
        {state: RespinSpinUIState, transitions: [RespinIdleUIState]},
        {state: PickBonusUIState, transitions: [DisabledUIState]},
        {state: HoldForTurboUIState, transitions: [HoldForTurboUIState, ...checkFeatureTransitions, IdleUIState]},
    ]
};